import PatientCharts from './PatientCharts';
export default PatientCharts;
